<template>
  <div class="nx-form-clearable-field">
    <v-layout
      row
      wrap
    >
      <component
        :is="preparedFieldConfig.component"
        ref="field"
        class="grow"
        :label="preparedFieldConfig.label"
        :name="preparedFieldConfig.name"
        :value="fieldValue"
        :validation="preparedFieldConfig.validation"
        :disabled="preparedFieldConfig.params.disabled || isCleared"
        v-bind="preparedFieldConfig.params"
        v-on="$listeners"
      />
      <v-tooltip
        v-show="isCleared"
        bottom
      >
        <v-btn
          slot="activator"
          class="mt-3"
          color="primary"
          flat
          icon
          @click="unclearField"
        >
          <v-icon medium>
            edit
          </v-icon>
        </v-btn>
        <span v-html="$t('message.common.edit')" />
      </v-tooltip>
      <v-tooltip
        v-show="!isCleared"
        bottom
      >
        <v-btn
          slot="activator"
          class="mt-3"
          color="primary"
          flat
          icon
          @click="clearField"
        >
          <v-icon medium>
            close
          </v-icon>
        </v-btn>
        <span v-html="$t('message.form.clearField')" />
      </v-tooltip>
    </v-layout>
  </div>
</template>

<script>
import PrepareFieldsConfig from '@/modules/form/mixins/prepare-fields-config';
import FormElement from '@/modules/form/mixins/form-element';

export default {
  name: 'NxFormClearableField',
  mixins: [PrepareFieldsConfig, FormElement],
  props: {
    fieldConfig: {
      type: Object,
      required: true,
    },
    formValue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    key() {
      return `clearable-field.${this.field}`;
    },
    field() {
      return this.fieldConfig.field;
    },
    fieldValue() {
      return this.formValue[this.field];
    },
    preparedFieldConfig() {
      return this.prepareFieldConfig(this.fieldConfig, this.key, this.scope);
    },
    clearFields() {
      return this.formValue.clearFields || [];
    },
    isCleared() {
      return this.clearFields.includes(this.field);
    },
  },
  methods: {
    async clearField() {
      const values = new Set([
        ...this.clearFields,
        this.field,
      ]);
      this.$parentForm.updateField('clearFields', Array.from(values));
      this.$parentForm.updateField(this.field, undefined);
    },
    async unclearField() {
      this.$parentForm.updateField('clearFields', this.clearFields.filter(field => field !== this.field));
    },
  },
};
</script>
